import React, { createRef } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { COLOR_TEXT_DISABLED } from '../General/Variables';

const FloqTextInput = ({
    value,
    onChange,
    onMouseEnter,
    onMouseLeave,
    label,
    error,
    disabled = false,
    hasClearButton = false,
    rows,
    onFocus,
    onBlur,
    helperText,
    prefix,
    decorationIcon,
    endAdornment = null,
    size,
}) => {
    const inputRef = createRef();
    const multiline = !!rows && rows > 1;

    const onChangeLocal = event => {
        const { value } = event.target;

        onChange(value);
    };

    const onClearInput = () => onChange('');

    return (
        <Box
            sx={{
                m: 0,
                flexGrow: 1,
                display: 'flex',
            }}
        >
            {decorationIcon && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        mr: '16px',
                        height: '58px',
                    }}
                >
                    {decorationIcon}
                </Box>
            )}
            <TextField
                size={size || undefined}
                inputRef={inputRef}
                value={value}
                onChange={onChangeLocal}
                label={label}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                variant="filled"
                sx={{ width: '100%' }}
                disabled={disabled}
                error={!!error}
                helperText={error || helperText}
                onFocus={onFocus}
                onBlur={onBlur}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <Stack direction="row" alignItems="center">
                            {endAdornment}
                            {!disabled && hasClearButton && value && (
                                <InputAdornment position="end" sx={{ marginRight: '0px' }}>
                                    <IconButton onClick={onClearInput}>
                                        <CloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            )}
                        </Stack>
                    ),
                    disableUnderline: true,
                    startAdornment: prefix && (
                        <InputAdornment
                            sx={{ marginRight: '0px', marginBottom: '-2px' }}
                            position="start"
                        >
                            <Typography sx={{ color: COLOR_TEXT_DISABLED }}>{prefix}</Typography>
                        </InputAdornment>
                    ),
                }}
                multiline={multiline}
                rows={rows}
            />
        </Box>
    );
};

export default FloqTextInput;
